export default {
  slips: {
    list: [],
    total: 0
  },

  currentSlip: {}
}
